<template>
  <section :class="$style.open_hour">
    <div :id="$style.opening_hours">
      <sub-title :title="'開館時間'"></sub-title>
      <div :id="$style.time">9:00 &#9655; 17:00</div>
    </div>
    <div :id="$style.close_day">
      <sub-title :title="'休館日'"></sub-title>毎週火曜日 および 12月31日〜1月2日
      <br><br><u>ただし下記期間は火曜日も開館しております。</u>
      <ul>
        <li>ゴールデンウィーク【4月29日〜5月6日】</li>
        <li>お盆【8月13日〜8月16日】</li>
        <li>年始【1月3日〜1月6日】</li>
      </ul>
    </div>
  </section>
</template>

<script lang="ts">
import Vue from "vue";
import SubTitle from "@/components/atoms/SubTitle.vue";

export default Vue.extend({
  name: "OpenHourVisual",
  components: {
    SubTitle
  }
});
</script>

<style lang="scss" module>
@media only screen and (max-width: 1023px) {
  .open_hour {
    #opening_hours {
      margin-bottom: 20px;
      #time {
        background-color: rgba(63, 107, 120, 1);
        color: #fff;
        height: 35px;
        font-size: 19px;
        display: flex;
        align-items: center;
        padding-left: 20px;
      }
    }
  }
}
@media only screen and (min-width: 1024px) {
  .open_hour {
    #opening_hours {
      margin-bottom: 20px;
      #time {
        background-color: rgba(63, 107, 120, 1);
        color: #fff;
        height: 35px;
        font-size: 19px;
        display: flex;
        align-items: center;
        padding-left: 20px;
      }
    }
  }
}
</style>
